export default "__VITE_ASSET__DBOIwHuu__"